import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../../store/createStore';

import {
  StoreCardContainer,
  // HeaderContainer,
  StoreCard,
  StoreInfo,
  StoreTitle,
  StoreDescription,
  StorePrice,
  PriceValue,
  RadioButton,
  StoreAddressInfo,
  AddressText,
  CardHeader,
  CardContent,
} from './styles';

interface StoreAddressCardProps {
  headerButton?: React.ReactNode;
}

const StoreAddressCard: React.FC<StoreAddressCardProps> = ({
  headerButton,
}) => {
  const { store } = useSelector((state: StoreState) => state.parameter);

  if (!store) {
    return null;
  }

  return (
    <StoreCardContainer>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '0 0 20px 0',
          gap: '24px',
        }}
      >
        <h4 style={{ margin: '0', color: '#333', flex: '1' }}>
          Retirar na Loja
        </h4>
        <div style={{ flexShrink: 0 }}>{headerButton}</div>
      </div>

      <StoreCard>
        <CardHeader>
          <CardContent>
            <RadioButton />

            <StoreInfo>
              <StoreTitle>{store.name}</StoreTitle>
              <StoreDescription>Retirada gratuita na loja</StoreDescription>
            </StoreInfo>
          </CardContent>

          <StorePrice>
            <PriceValue>Grátis</PriceValue>
          </StorePrice>
        </CardHeader>

        {/* Informações do endereço da loja */}
        <StoreAddressInfo>
          <AddressText>
            <strong>Retirar em:</strong> {store.address}, {store.number}
            {store.complement && ` - ${store.complement}`} -{' '}
            {store.neighborhood} - {store.city}/{store.state} - CEP:{' '}
            {store.zip_code}
          </AddressText>
        </StoreAddressInfo>
      </StoreCard>
    </StoreCardContainer>
  );
};

export default StoreAddressCard;
